import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query({
      query: (data) => `${apiUrl.donorRegistartion}?Pin=${data.pin}&Birthdate=${data.birthDate}&LastName=${data.lastName}`,
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetProfileQuery
} = extendedApi;
